module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumb-bar', {
    attrs: {
      "crumbs": [{
        name: 'Groups'
      }, {
        name: 'Activities and Services'
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_vm._m(0), _vm._v(" "), (_vm.user.access >= 5 && _vm.step === 2) ? _c('span', {
    staticClass: "pull-right options-gear",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.columnsModalShow()
      }
    }
  }, [_c('i', {
    staticClass: "icon-settings right"
  })]) : _vm._e(), _vm._v(" "), _c('groups-forms-columns', {
    attrs: {
      "id": "groups-forms-columns"
    },
    on: {
      "confirmed": _vm.saveParticipantColumns
    }
  }), _vm._v(" "), (_vm.step === 3) ? _c('div', {
    staticClass: "selected-info"
  }, [_vm._v("\n                " + _vm._s(_vm.selected.length) + " participant"), (_vm.selected.length > 1) ? _c('span', [_vm._v("s")]) : _vm._e(), _vm._v(" selected\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [(_vm.step === 1) ? _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.forms), function(form) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_c('h4', {
      staticClass: "pull-left"
    }, [_vm._v(_vm._s(form.name))]), _vm._v(" "), _c('button', {
      staticClass: "btn green pull-right",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.selectParticipants(form.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                    Complete Form\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('div', [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group form-md-line-input has-warning"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-control input-icon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Type to search..."
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-control-focus"
  })]), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), (((_vm.participants.length > 0) || _vm.filterActive) && _vm.serverColumns.length) ? _c('div', {
    staticClass: "vue-good-table"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.participants,
      "pagination-options": {
        enabled: true,
        perPageDropdown: [10, 20, 50, 100, 200, 500],
        dropdownAllowAll: true,
        perPage: this.serverParams.perPage
      },
      "mode": "remote",
      "totalRows": _vm.totalRecords
    },
    on: {
      "on-page-change": _vm.onPageChange,
      "on-sort-change": _vm.onSortChange,
      "on-column-filter": _vm.onColumnFilter,
      "on-per-page-change": _vm.onPerPageChange
    },
    scopedSlots: _vm._u([{
      key: "table-column",
      fn: function(props) {
        return [(props.column.label == 'All') ? _c('label', {
          staticClass: "mt-checkbox mt-checkbox-outline"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.selectAll),
            expression: "selectAll"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(_vm.selectAll) ? _vm._i(_vm.selectAll, null) > -1 : (_vm.selectAll)
          },
          on: {
            "change": function($event) {
              var $$a = _vm.selectAll,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.selectAll = $$a.concat([$$v]))
                } else {
                  $$i > -1 && (_vm.selectAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.selectAll = $$c
              }
            }
          }
        }), _vm._v(" "), _c('span')]) : _c('span', [_vm._v("\n                        " + _vm._s(props.column.label) + "\n                      ")])]
      }
    }, {
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'before') ? [_c('label', {
          staticClass: "mt-checkbox mt-checkbox-outline"
        }, [_c('input', {
          attrs: {
            "type": "checkbox",
            "disabled": props.row.disabled
          },
          domProps: {
            "value": props.row.id,
            "checked": _vm.selected.includes(props.row.id)
          },
          on: {
            "click": _vm.selectRow
          }
        }), _vm._v(" "), _c('span')])] : [_c('span', {
          class: {
            'disabled': props.row.disabled
          }
        }, [_vm._v(_vm._s(props.formattedRow[props.column.field]))])]]
      }
    }], null, false, 120757867)
  })], 1) : _c('div', {
    staticClass: "not-found-results"
  }, [_c('h4', [_vm._v("Sorry, no search results were found.")]), _vm._v(" "), _c('h5', [_vm._v("Search Suggestions:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Check your spelling")]), _vm._v(" "), _c('li', [_vm._v("Search by " + _vm._s(_vm.participantSingularName) + " Name, System ID or Organization ID")])])]), _vm._v(" "), _c('button', {
    staticClass: "btn green pull-left",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.selectForm()
      }
    }
  }, [_vm._v("\n                  Back\n                ")]), _vm._v(" "), (_vm.selected.length > 0) ? _c('button', {
    staticClass: "btn green pull-right",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.completeForm()
      }
    }
  }, [_vm._v("\n                  Next\n                ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.step === 3) ? _c('div', [_c('vue-form-render', {
    ref: "formRender",
    attrs: {
      "schema": _vm.form.schema,
      "conditions": _vm.form.conditions,
      "calculations": _vm.form.calculations,
      "values": _vm.form.values,
      "date-format": _vm.user.date_format,
      "user-access-level": _vm.user.access,
      "validation-conditions": _vm.form.extra_validation_rules,
      "hideValues": _vm.form.hide_values,
      "form-previews": _vm.form.form_previews,
      "name": "widgetForm"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn green pull-left",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.selectParticipants()
      }
    }
  }, [_vm._v("\n                  Back\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn green pull-right mt-ladda-btn ladda-button groups-btn-submit",
    attrs: {
      "data-style": "expand-left"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_c('span', {
    staticClass: "ladda-label"
  }, [_vm._v("Submit")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption caption-md"
  }, [_c('span', {
    staticClass: "caption-subject bold uppercase"
  }, [_vm._v("Activities and Services")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn btn-right"
  }, [_c('button', {
    staticClass: "btn green mt-ladda-btn ladda-button search-btn-submit-pd",
    attrs: {
      "type": "submit",
      "data-style": "expand-left"
    }
  }, [_c('span', {
    staticClass: "ladda-label"
  }, [_vm._v("Search")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62b5ee66","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/GroupsForms.vue
// module id = 1667
// module chunks = 1